function ImageLoadHelper() {
	this.imageCount = 0;
	(this as any).images = [];
}

ImageLoadHelper.prototype.reset = function () {
	this.imageCount = 0;
	this.images = [];
};

ImageLoadHelper.prototype.start = function (node) {
	var that = this;
	this.images = node.find('img[src][src!=""]')
		.filter(function () {
			return $(this)
				.closest('.tooltip').length === 0;
		});
	if (this.images.length > 0) {
		this.images.each(function () {
			$(this)
				.one('load error', function () {
					that.updateImageCount();
				})
				.each(function () {
					if (this.complete) {
						($(this) as any)
							.load();
					}
				});
		});
	} else {
		$(document)
			.trigger('imageLoadHelperDone');
	}
};

ImageLoadHelper.prototype.updateImageCount = function () {
	if (this.imageCount == 0 || this.imageCount > this.images.length) {
		this.imageCount = this.images.length;
	}
	this.imageCount--;
	if (this.imageCount == 0) {
		$(document)
			.trigger('imageLoadHelperDone');
	}
};

ImageLoadHelper.prototype.preloadImages = function (imageSources, callback) {
	var promises = [];
	for (var i = 0; i < imageSources.length; i++) {
		(function (url, promise) {
			var img = new Image();
			img.onload = function () {

				promise.resolve();
			};
			img.src = url;
		})(imageSources[i], promises[i] = $.Deferred());
	}
	$.when.apply($, promises)
		.done(callback());
};

export default new ImageLoadHelper();
